export default __webpack_public_path__ + "static/media/logo_horizontal_white.465fbe06.png";